import * as React from 'react'
import { PropsWithChildren } from 'react'

import { NotFound as DesignSystemNotFound } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  notFound: boolean
}

const NotFound = ({ notFound, children }: PropsWithChildren & Props) => {
  if (notFound)
    return (
      <DesignSystemNotFound
        title={i18n.t('errors.page_not_found.title')}
        description={i18n.t('errors.page_not_found.description')}
      />
    )

  return children
}

export default NotFound
